import { ServiceSessionUserEvent } from '@modules/ServiceModule';
import { InboxContext } from '../types';
import TasksModule from '@modules/TasksModule';
import { AcceptedOnDevice, TaskState } from '@modules/TasksModule/types';
import {
  setCallToCompleted,
  setCallToWrapup,
} from '@modules/InboxModule/callHandlers/callStateHandler';

function handleSessionHangup(
  context: InboxContext,
  event: ServiceSessionUserEvent,
) {
  const task = TasksModule.getTask(event.sessionSid);

  if (!task) {
    return;
  }

  if (TasksModule.getTask(task.id)) {
    TasksModule.setTaskAttribute(task.id, 'callEndedTime', Date.now());
  }

  // we only want to transition tasks that are in accepted state
  if (task.state !== TaskState.Accepted) {
    return;
  }

  if (task?.attributes.acceptedOn === AcceptedOnDevice.OtherDevice) {
    if (task.attributes.shouldClassify) {
      setCallToWrapup(context, event.sessionSid);
    } else if (!task.attributes.shouldClassify) {
      setCallToCompleted(context, event.sessionSid, false);
    }
  }
}

export default handleSessionHangup;
